import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslations from './locales/en/translation.json';
import zhCNTranslations from './locales/zh-CN/translation.json';
import zhTWTranslations from './locales/zh-TW/translation.json';

const customDetector = {
  name: 'customDetector',

  lookup(options) {
    let lang = localStorage.getItem('i18nextLng');
    if ((!lang || lang === "null") && typeof navigator !== 'undefined') {
      lang = navigator.languages ? navigator.languages[0] : navigator.language;
    }
    return (lang === 'zh') ? 'zh-CN' : lang;
  },

  cacheUserLanguage(lng, options) {
    localStorage.setItem('i18nextLng', lng);
  }
};

i18n
  .use(initReactI18next)
  .use({
    type: 'languageDetector',
    async: false, // flags below detection to be sync
    detect: customDetector.lookup, // override the method of checking the locale
    init: () => {},
    cacheUserLanguage: customDetector.cacheUserLanguage // cache for the customDetector
  })
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      'zh-CN': {
        translation: zhCNTranslations
      },
      'zh-TW': {
        translation: zhTWTranslations
      }
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
